import React from "react";
import AdminHeader from "../components/Layout/AdminHeader";
import AdminSideBar from "../components/Admin/Layout/AdminSideBar";
import AllWithdraw from "../components/Admin/AllWithdraw";

const AdminDashboardWithdraw = () => {
  return (
    <div className="admin-dashboard-container">
      <AdminHeader />
      <div className="admin-dashboard-content">
        <div className="admin-dashboard-wrapper">
          <div className="admin-dashboard-sidebar">
            <AdminSideBar active={7} />
          </div>
          <div className="admin-dashboard-main admin-page-shell">
            <header className="admin-page-hero">
              <div>
                <p className="admin-page-eyebrow">Super Admin Finance</p>
                <h1>Withdraw Requests</h1>
                <p className="admin-page-copy">Review payout requests, processing status, and seller withdrawal details.</p>
              </div>
            </header>
            <AllWithdraw />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardWithdraw;
